/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S2_P1Inputs */

const en_guide_json_rest_api_s2_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API responses typically include JSON in the body with a <code>Content-Type: application/json</code> header. The response structure usually follows conventions like wrapping data in a top-level object with metadata.`)
};

const ko_guide_json_rest_api_s2_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 응답은 일반적으로 <code>Content-Type: application/json</code> 헤더와 함께 본문에 JSON을 포함합니다. 응답 구조는 보통 최상위 객체에 메타데이터와 함께 데이터를 감싸는 규칙을 따릅니다.`)
};

const ja_guide_json_rest_api_s2_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIレスポンスは通常、<code>Content-Type: application/json</code>ヘッダーとともにボディにJSONを含みます。レスポンス構造は一般的に、メタデータを含むトップレベルオブジェクトでデータをラップする規約に従います。`)
};

/**
* | output |
* | --- |
* | "API responses typically include JSON in the body with a <code>Content-Type: application/json</code> header. The response structure usually follows convention..." |
*
* @param {Guide_Json_Rest_Api_S2_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s2_p1 = /** @type {((inputs?: Guide_Json_Rest_Api_S2_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S2_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s2_p1(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s2_p1(inputs)
	return ja_guide_json_rest_api_s2_p1(inputs)
});